export var isOptionGroup = function isOptionGroup(option) {
  return !!option.options;
};